<div class="">

  <div class="col-md-12">

    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">إدارة الرحلات المجدولة</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #search (keyup)="($event)" class="form-control transparent" placeholder="بحث في الرحلات" aria-label="Recipient's username" aria-describedby="basic-addon2">
            <i class="fa fa-times-circle pointer left" *ngIf="search.value.length>0" (click)="removeSearch()"></i>

          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="row" *ngIf="loader">
    <div class="col-md-12">
      <div class="text-center">
        <div class="loader"></div>
      </div>
    </div>
  </div>

  <div class="row" >
    <div class="col-md-12">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="home-tab" data-toggle="tab" href="#go" role="tab" aria-controls="home" aria-selected="true">

            رحلات الذهاب
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="profile-tab" data-toggle="tab" href="#back" role="tab" aria-controls="profile" aria-selected="false">
            رحلات العودة


          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="go" role="tabpanel" aria-labelledby="home-tab">
      <div class="row" *ngFor="let travel of data|search: 'travel_start_name' : search.value">
        <div class="col-md-12 ">

          <div class="bg-white pb-2">
            <div class="row mb-0 pb-0">
              <div class="col-md-12">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item no-line ml-2 "><img src="../../assets/images/icons/home.svg"/></li>
                    <li class="breadcrumb-item no-line" > {{travel['travel_start_name']}}   </li>
                    <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                    <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/gps.svg"> </li>
                    <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                    <li class="breadcrumb-item no-line" > ({{travel['way']=='go'?'ذهاب':'عودة'}}) </li>
                    <li class="ml-auto" >

                      <div class="d-flex flex-row">
<!--                        <div>-->
<!--                          <button data-target="#assigneBus" data-toggle="modal"  (click)="getAssignBus(travel._id)" type="button" class="btn background-blue-g w-194 radius-16   "  >تعيين حافلة</button>-->

<!--                        </div>-->
                        <div>

<!--                          <i class="fa fa-map pointer primary-color"></i>-->
                        </div>
<!--                        <div class="dropdown">-->
<!--                          <i class="fa fa-ellipsis-h text-black-50 pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>-->

<!--                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
<!--                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>-->
<!--                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>-->

<!--                          </div>-->
<!--                        </div>-->

                      </div>


                    </li>

                  </ol>

                </nav>
              </div>
            </div>
            <div class="col-md-12">


              <div class="row mt-0 pt-0">
                <div class="col-md-4 text-left">
                  <span class="trip-text">نقاط التوقف</span>
                </div>

              </div>
              <div class="row text-left">
                <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border pointer"   data-toggle="modal" data-target="#showStudents" (click)="setPoint(travel,way._id)"  *ngFor="let way of travel.way_points">
                  <div class="row m-0  pt-1">
                    <div class="col-md-12">
                      <img src="../../assets/images/icons/home.svg" class="mr-2" width="20">
                      <span class="font-12 bold">{{way.label}}</span>
                    </div>
                  </div>
                  <div class="row m-0 pb-2">
                    <div class="col-md-12">
                      <span class="font-12 bold"><img src="../../assets/images/icons/time.svg" class="mr-2"/>{{way.time}}</span>

                    </div>
                  </div>
                  <div class="row m-0 pb-2 background-blue-g text-center">
                    <div class="col-md-12">
                      <span class="font-12 bold"><span>عدد الطلبة المجدولين :   </span>{{travel.waypoints_count[way._id]?travel.waypoints_count[way._id]:0}}</span>
                      </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <span class="trip-text">أيام العمل على الخط</span>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-12  d-flex flex-row">
                  <div class="small-box mr-2" *ngFor="let day of travel.work_days">
                    <span>{{days[day]}}</span>
                  </div>

                </div>


              </div>

              <div class="row">
                <div class="col-md-12 text-left">
                  <span class="trip-text">الحافلات على الخط</span>
                </div>
              </div>
              <div class="row text-left">
                <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border"  *ngFor="let bus of travel.bus">
                  <div class="row m-0  pt-1">
                    <div class="col-md-12">
                      <img src="../../assets/images/icons/busIconSmall.svg" class="mr-2" width="20">
                      <span class="font-12 bold">{{bus["bus_identity"]}}</span>
                    </div>
                  </div>
                  <div class="row m-0 pb-2" *ngFor="let driver of bus.drivers">
                    <div class="col-md-12">

                      <span class="font-12 bold"><img src="../../assets/images/icons/userIconSmall.svg" class="mr-2"/>{{driver.name}}</span>

                    </div>
                  </div>
                </div>


              </div>
              <div class="row">
                <div class="col-md-12 text-left">
                  <span class="trip-text">عدد الطلاب</span>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-12  d-flex flex-row">
                  <div class="small-box mr-2">
                    <span>{{travel["count"]}}</span>
                  </div>

                </div>


              </div>


            </div>
          </div>

        </div>
      </div>

        </div>
        <div class="tab-pane fade show active" id="back" role="tabpanel" aria-labelledby="home-tab">
          <div class="row" *ngFor="let travel of back|search: 'travel_start_name' : search.value">
            <div class="col-md-12 ">

              <div class="bg-white pb-2">
                <div class="row mb-0 pb-0">
                  <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item no-line ml-2 "><img src="../../assets/images/icons/home.svg"/></li>
                        <li class="breadcrumb-item no-line" > {{travel['travel_start_name']}}   </li>
                        <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/arrow.svg"/> </li>
                        <li class="breadcrumb-item no-line" > <img src="../../assets/images/icons/gps.svg"> </li>
                        <li class="breadcrumb-item no-line" > {{travel['travel_end_name']}} </li>
                        <li class="breadcrumb-item no-line" > ({{travel['way']=='go'?'ذهاب':'عودة'}}) </li>
                        <li class="ml-auto" >

                          <div class="d-flex flex-row">
                            <!--                        <div>-->
                            <!--                          <button data-target="#assigneBus" data-toggle="modal"  (click)="getAssignBus(travel._id)" type="button" class="btn background-blue-g w-194 radius-16   "  >تعيين حافلة</button>-->

                            <!--                        </div>-->
                            <div>

                              <!--                          <i class="fa fa-map pointer primary-color"></i>-->
                            </div>
                            <!--                        <div class="dropdown">-->
                            <!--                          <i class="fa fa-ellipsis-h text-black-50 pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>-->

                            <!--                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
                            <!--                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal" (click)="getTravel(travel._id)">تعديل</a>-->
                            <!--                            <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(travel)">حذف</a>-->

                            <!--                          </div>-->
                            <!--                        </div>-->

                          </div>


                        </li>

                      </ol>

                    </nav>
                  </div>
                </div>
                <div class="col-md-12">


                  <div class="row mt-0 pt-0">
                    <div class="col-md-4 text-left">
                      <span class="trip-text">نقاط التوقف</span>
                    </div>

                  </div>
                  <div class="row text-left">
                    <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border pointer"   data-toggle="modal" data-target="#showStudents" (click)="setPoint(travel,way._id)"  *ngFor="let way of travel.way_points">
                      <div class="row m-0  pt-1">
                        <div class="col-md-12">
                          <img src="../../assets/images/icons/home.svg" class="mr-2" width="20">
                          <span class="font-12 bold">{{way.label}}</span>
                        </div>
                      </div>
                      <div class="row m-0 pb-2">
                        <div class="col-md-12">
                          <span class="font-12 bold"><img src="../../assets/images/icons/time.svg" class="mr-2"/>{{way.time}}</span>

                        </div>
                      </div>
                      <div class="row m-0 pb-2 background-blue-g text-center">
                        <div class="col-md-12">
                          <span class="font-12 bold"><span>عدد الطلبة المجدولين :   </span>{{travel.waypoints_count[way._id]?travel.waypoints_count[way._id]:0}}</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-12 text-left">
                      <span class="trip-text">أيام العمل على الخط</span>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-12  d-flex flex-row">
                      <div class="small-box mr-2" *ngFor="let day of travel.work_days">
                        <span>{{days[day]}}</span>
                      </div>

                    </div>


                  </div>

                  <div class="row">
                    <div class="col-md-12 text-left">
                      <span class="trip-text">الحافلات على الخط</span>
                    </div>
                  </div>
                  <div class="row text-left">
                    <div class="col-md-3 col-xl-3 col-lg-3 mb-2 p-0 box-border"  *ngFor="let bus of travel.bus">
                      <div class="row m-0  pt-1">
                        <div class="col-md-12">
                          <img src="../../assets/images/icons/busIconSmall.svg" class="mr-2" width="20">
                          <span class="font-12 bold">{{bus["bus_identity"]}}</span>
                        </div>
                      </div>
                      <div class="row m-0 pb-2" *ngFor="let driver of bus.drivers">
                        <div class="col-md-12">

                          <span class="font-12 bold"><img src="../../assets/images/icons/userIconSmall.svg" class="mr-2"/>{{driver.name}}</span>

                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="row">
                    <div class="col-md-12 text-left">
                      <span class="trip-text">عدد الطلاب</span>
                    </div>
                  </div>
                  <div class="row ">
                    <div class="col-md-12  d-flex flex-row">
                      <div class="small-box mr-2">
                        <span>{{travel["count"]}}</span>
                      </div>

                    </div>


                  </div>


                </div>
              </div>

            </div>
          </div>

        </div>

    </div>
  </div>



</div>

<div class="modal fade" id="showStudents" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">الطلاب على النقطة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row" >
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-icons">

                <input #search2 type="text" (keyup)="($event)" class="form-control transparent" placeholder="بحث " aria-label="Recipient's username" aria-describedby="basic-addon2">
                <i class="fa fa-search icon">
                </i>
                <i class="fa fa-times-circle pointer left" *ngIf="search2.value.length>0" (click)="removeSearch()"></i>

              </div>
            </div>
          </div>
        </div>
        <table class="table no-border">

          <tbody>
          <tr *ngFor="let row of selectedPoints['students']|search: 'name' : search2.value;let i=index">
            <th scope="row"  class="no-border" width="75%">
              <div class="media align-items-center">
                <a href="javascript:void(0)" class=" rounded-circle mr-3">
                  <ngx-avatar *ngIf="!row.profile_photo" name="{{row.name}}"></ngx-avatar>

                  <img  *ngIf="row.profile_photo" [src]="row.profile_photo?row.profile_photo:'assets/images/profile-square.jpg'" class="avatar-person"/>

                </a>
                <div class="" >
                  <span class="mb-0 text-sm">{{row.name}}</span>
                </div>
              </div>
            </th>

          </tr>

          </tbody>
        </table>

      </div>

    </div>

  </div>
</div>
